import { Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';

export function RoleRedirect() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/arab" replace />;
  }

  if (user.role === 'ADMIN') {
    return <Navigate to="/admin" replace />;
  }
  if (user.role === 'TEACHER') {
    return <Navigate to="/teacher" replace />;
  }
  return <Navigate to="/dashboard" replace />;
}
